module.exports = __webpack_public_path__ + "product-pure-powder-capsule-main-thumb-01.jpg?c515f9b19941a13361615f72e0e1260b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-pure-powder-capsule-main-thumb-01.jpg
// module id = 80
// module chunks = 0